import { render } from "./profileView.vue?vue&type=template&id=545f5f70"
import script from "./profileView.vue?vue&type=script&lang=js"
export * from "./profileView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__